module.exports = __webpack_public_path__ + "static/img/Spring.519f6082.png";